import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/global/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/global/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/global/ReduxProvider.tsx");
